import { defineStore } from "pinia"

export const usePageinfo = defineStore('pageinfo', {
    // defineStore(id(一个储存库标识))
    state: () => ({
        userFrom: null,
        rotationNum: null,
        loginBackUrl: null,
        infoJson: null,
        inviteHallId: null,
        chatLogin: null,
        chatSendMsg: null,
        hid: null,
        fid: null,
        did: null,
        showWelcomeAnimation: false
    })
})